import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const Theme = responsiveFontSizes(createTheme({
    typography: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        useNextVariants: true,
		htmlFontSize: window.$umas4m_config.htmlFontSize,
		fontSize: 15,
		h1: {
			fontWeight: 400,
		},
		h2: {
			fontWeight: 400,
		}
    },
	breakpoints: {
		keys: ['xs', 'sm', 'smd', 'md', 'mdl', 'lg', 'xl'],
		values: {
			xs: 0,
			sm: 650,
			smd: 750,
			md: 960,
			mdl: 1060,
			lg: 1280,
			xl: 1920
		}
	},
	palette: {
		common: {
			black:"#000",
			white:"#fff"
		},
		background: {
			paper:"#fff",
			default:"rgb(246, 248, 255)"
		},
		primary:{
			verypale: "rgb(235, 240, 250)",
			lightpale: "#f1f8fe",
			light:"rgb(33, 150, 243)",
			main:"rgb(42, 85, 160)", // U3A NV style guide blue
			dark:"rgb(29, 58, 109)",
			//contrastText:"rgb(247, 244, 225)"
		},
		secondary:{
			extremelypale: "rgb(255, 253, 245)",
			verypale: "rgb(255, 250, 234)",
			pale: "rgb(255, 244, 204)",
			light:"rgb(255, 231, 147)",
			main:"rgb(251, 209, 54)", // U3A NV style guide yellow
			dark:"rgb(255, 206, 0)",
			//contrastText:"rgb(78, 78, 80)"
		},
		tertiary: {
			light: "rgb(247, 244, 225)", // U3A NV style guide beige
			grey: "rgb(78, 78, 80)", // U3A NV style guide grey
			pale: "rgb(245, 245, 245)" // Very pale grey
		},
		error:{
			light:"#ff0000",
			main:"#ea0000",
			dark:"#cc0000",
			contrastText:"#fff"
		},
		text:{
			primary:"rgb(0, 0, 0)",
			secondary: "rgb(39, 39, 40)",
			disabled:"rgb(136, 136, 136)",
			hint:"rgb(136, 136, 136)"
		}
	}
}));

export default Theme;